import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowLeftIcon, InstagramIcon, PhoneIcon } from 'lucide-react';
import { Button } from '../UI/Button';
import { trackEvent } from '../../src/utils/GoogleAnalytics';
// Global in-flight lock declaration
declare global {
  interface Window {
    __btbConvInFlight?: boolean;
  }
}
// Single storage key for conversion tracking
const STORAGE_KEY = 'btb_conversion_tracked_v1';
export const SuccessPage = () => {
  const firedRef = useRef(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Prevent StrictMode double-run and re-entries
    if (firedRef.current) return;
    firedRef.current = true;
    // Prevent duplicate conversions across refresh/back navigation
    if (sessionStorage.getItem(STORAGE_KEY) === '1') {
      console.log('🔒 Custom events already tracked this session. Skipping.');
      return;
    }
    // Lock to prevent duplicate firing on refresh
    sessionStorage.setItem(STORAGE_KEY, '1');
    // Simple implementation for custom events only
    const fbq = window.fbq as undefined | ((...a: any[]) => void);
    const eventId = crypto?.randomUUID?.() || String(Date.now());
    if (fbq) {
      // We only track the custom event now - NO Lead event since it's automatic
      fbq('trackCustom', 'offerte_ontvangen', {
        status: 'success',
        timestamp: new Date().toISOString()
      }, {
        eventID: eventId
      });
      console.log('✅ Custom offerte_ontvangen event sent with eventID:', eventId);
    }
    // GA is fine
    trackEvent('form_submission', {
      event_category: 'form',
      event_label: 'quote_request',
      non_interaction: false
    });
  }, []);
  return <div className="bg-white rounded-xl shadow-lg p-6 md:p-10 transition-all duration-500 animate-fadeIn" data-id="element-372">
      <div className="flex flex-col items-center justify-center py-8 md:py-12" data-id="element-373">
        <div className="relative" data-id="element-374">
          <div className="w-20 h-20 md:w-24 md:h-24 bg-green-100 rounded-full flex items-center justify-center mb-8 animate-success" data-id="element-375">
            <CheckIcon className="w-10 h-10 md:w-12 md:h-12 text-green-600" data-id="element-376" />
          </div>
          <div className="absolute top-0 left-0 w-full h-full rounded-full animate-ping bg-green-100 opacity-75" data-id="element-377"></div>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-[#111010] mb-3 text-center" data-id="element-378">
          Bedankt voor uw aanvraag!
        </h1>
        <div className="max-w-md mx-auto" data-id="element-379">
          <p className="text-gray-600 text-center mb-8" data-id="element-380">
            We hebben uw offerte-aanvraag succesvol ontvangen. Een van onze
            medewerkers zal binnen <span className="font-semibold" data-id="element-381">48 uur</span>{' '}
            contact met u opnemen om uw project te bespreken.
          </p>
          <div className="bg-[#FEECCF] rounded-lg p-4 mb-8" data-id="element-382">
            <p className="text-[#111010] text-sm text-center" data-id="element-383">
              <strong data-id="element-384">Tip:</strong> Volg ons op Instagram om inspiratie op te
              doen en onze recente projecten te bekijken!
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md" data-id="element-385">
          <a href="https://www.btbbouwbedrijf.nl" className="flex-1" data-id="element-386">
            <Button variant="outline" className="w-full" data-id="element-387">
              <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-388" />
              Terug naar website
            </Button>
          </a>
          <a href="https://www.instagram.com/btbbouwbedrijf/" target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-389">
            <Button variant="secondary" className="w-full" data-id="element-390">
              <InstagramIcon className="mr-2 h-4 w-4" data-id="element-391" />
              Volg ons op Instagram
            </Button>
          </a>
        </div>
        <div className="mt-12 border-t border-gray-100 pt-6 w-full max-w-md" data-id="element-392">
          <div className="flex flex-col items-center" data-id="element-393">
            <p className="text-sm text-gray-500 text-center mb-3" data-id="element-394">
              Heeft u een vraag? Bel ons direct:
            </p>
            <a href="tel:+31625387128" className="flex items-center justify-center text-[#111010] font-medium hover:text-[#FCCA86] transition-colors py-2 px-4 rounded-lg hover:bg-gray-50" data-id="element-395">
              <PhoneIcon className="h-5 w-5 mr-2" data-id="element-396" />
              +31 6 253 871 28
            </a>
          </div>
        </div>
      </div>
    </div>;
};